// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"IconWrapper_iconWrapper__lreRx"};